import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {ServiceJobDTOModel} from '../../models/service-job-DTO.model';
import {JobListService} from '../../services/database/resource/job-list.service';
import {LoadingController, ModalController} from '@ionic/angular';
import {GeneralService} from '../../services/general.service';
import {LegacyJobDetailPage} from '../../modals/legacy-job-detail/legacy-job-detail.page';
import {TestConnectionService} from '../../services/test-connection.service';
import {LokijsService} from '../../services/database/lokijs.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {StateManagerService} from '../../services/state-manager.service';

@Component({
    selector: 'job-details',
    templateUrl: './job-details.component.html',
    styleUrls: ['./job-details.component.scss'],
})
export class JobDetailsComponent implements OnInit {

    @Input() document: DocumentModel;
    display = true;
    loading: any;
    legacyJobs: ServiceJobDTOModel[];
    jobStatusList: any;
    currentJobStatus: number;

    constructor(private jobListService: JobListService,
                private loadingController: LoadingController,
                private generalServices: GeneralService,
                private modalController: ModalController,
                private testConnection: TestConnectionService,
                private collNames: CollectionsNames,
                private stateManager: StateManagerService) {
    }

    async ngOnInit() {
        this.jobStatusList = await this.stateManager.getCollection(this.collNames.JOBSTATUSLIST);
        this.currentJobStatus = this.document.serviceJob.jobStatus;
    }

    async fetchLegacyJobs(plantOrProductId: number) {
        console.log(this.document);
        this.loadingController.create({
            message: 'Please wait...',
            translucent: true,
            cssClass: 'custom-class custom-loading'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
        this.testConnection.pingServer().then(res => {
            if (res) {
                this.jobListService.getJobHistory(plantOrProductId).then(jobs => {
                    this.legacyJobs = jobs as ServiceJobDTOModel[];
                    this.loading.dismiss();
                    if (this.legacyJobs.length > 0) {
                        this.openHistory();
                    } else {
                        this.generalServices.createToast('No history for this plant item');
                    }
                }).catch(err => {
                    this.generalServices.createToast('Error occurred fetching job history');
                    this.loading.dismiss();
                });
            }
        }).catch(err => {
            this.generalServices.createToast('No connection to the server');
            this.loading.dismiss();
        });
    }

    async openHistory() {
        const modal = await this.modalController.create({
            component: LegacyJobDetailPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'jobList': this.legacyJobs,
                'document': this.document
            }
        });
        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                console.log(dataReturned);
            }
        });
        return await modal.present();
    }


    updateJobStatus(event: any) {
        console.log(event);
        this.document.serviceJob.jobStatus = event.target.value;
    }
}
